import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import LocLogged from '../../../../components/auth/institucional/locais'

function LocLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Órgãos da Prefeitura Municipal de Macuco" />
                <HeaderLogged />
                <Container>
                   <LocLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default LocLoggedScreen;